import React from 'react';
import styled from 'styled-components';
import { colors } from 'helpers/ColorHelper';

const StyledContainer = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StyledButton = styled.button`
  color: ${props => (props.disabled ? colors.BATTLESHIP_GREY : props.accentColor)};
  font-size: ${props => (props.isTitle ? '25px' : '16px')};
  border: none;
  padding: 0;
  border-radius: 0 !important;
  font-family: 'Circular-Black';
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  background: none;
`;

const StyledCurrentState = styled.div`
  display: inline;
  font-size: ${props => (props.isTitle ? '25px' : '16px')};
  font-family: 'Circular-Black';
`;

const CtaText = ({
  accentColor = colors.ULTRAMARINE_BLUE,
  breadcrumbBackTitle,
  breadCrumbCurrentTitle,
  ...rest
}) => {
  return (
    <StyledContainer>
      <StyledButton accentColor={accentColor} {...rest}>
        {breadcrumbBackTitle}
      </StyledButton>
      <StyledCurrentState {...rest}> - {breadCrumbCurrentTitle}</StyledCurrentState>
    </StyledContainer>
  );
};

export default CtaText;
